module.exports = __webpack_public_path__ + "assets/media/day13.6a54863f.mp3";